export class PostalAddress {
  constructor(
    public postalCode: string,    // 郵便番号.
    public prefecture: string,    // 都道府県名.
    public municipality: string,  // 市区町村名.
    public area: string,          // 町域名.
) {
  }
}
